import request from '@/service/lib/request'

/**
 * 设备 - 列表
 * @param {String} url 请求地址
 * @param {Object} data 请求参数
 */
export function list(companyId) {
  return request({
    url: '/api/v1/me/devices',
    method: 'get',
    params: { companyId }
  })
}

/**
 * 设备 - 列表 （不包括欧科奇）
 * @param {String} url 请求地址
 * @param {Object} params 请求参数
 */
export function localList(params) {
  return request({
    url: '/api/v2/me/local-devices',
    method: 'get',
    params
  })
}

/**
 * 设备 - 欧科奇列表
 * @param {String} url 请求地址
 * @param {Object} params 请求参数
 */
export function okq(companyId) {
  return request({
    url: '/api/v2/me/okq',
    method: 'get',
    params: { companyId }
  })
}
